import { CurrencyInvoiceType } from 'api/types/entity';

export const currencyInvoiceOptions = Object.values(CurrencyInvoiceType).map(
  (v) => ({
    label: v,
    value: v,
  })
);
